<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <el-date-picker
                v-model="search.date_range"
                type="daterange"
                size="small"
                :picker-options="date_picker_options"
                @change="dateCheck"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date">
              </el-date-picker> &nbsp;
              <el-select size="small" v-model="status_filter" placeholder="Choose status">
                <el-option
                  v-for="item in statusFilterOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select> &nbsp;
              <el-button :loading="loading.table" @click="page = 1; getList();" size="small" class="btn-default" icon="el-icon-search">Search</el-button>
              <el-button :loading="loading.table" @click="downloadReport();" size="small" class="btn-primary" icon="el-icon-download">Download</el-button>
            </div>
            <hr/>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Name</th>
                    <th>Customer Name</th>
                    <th>Customer Phone</th>
                    <th>Agent Name</th>
                    <th>Meeting Start Time</th>
                    <th>Meeting End Time</th>
                    <th>Duration</th>
                    <th>Participant</th>
                    <th>Cancelled At</th>
                    <th>Created At</th>
                    <!-- <th>Type</th> -->
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-loading="loading.table">
                  <tr v-for="(item, i) in reportList" :key="i">
                    <td>
                      <el-tag size="mini" :type="item.status_color">
                        {{ item.status_str }}
                      </el-tag>
                    </td>
                    <td>
                      {{ ucwords(item.name) }}
                    </td>
                    <td>
                      {{ item.contact.name }}
                    </td>
                    <td>
                      {{ item.contact.phone_number }}
                    </td>
                    <td>
                      {{ item.user?.name ? item.user.name : '-' }}
                    </td>
                    <td>
                      {{ item.meeting_start_at ? formatDate(item.meeting_start_at) : formatDate(item.created_at) }}
                    </td>
                    <td>
                      {{ item.meeting_end_at ? formatDate(item.meeting_end_at) : '' }}
                    </td>
                    <td>
                      {{ item.duration ? humanizeDuration(item.duration * 60000) : '0' }}
                    </td>
                    <td>
                      {{ item.participant }}
                    </td>
                    <td>
                      {{ item.cancelled_at ? formatDate(item.cancelled_at) : '-' }}
                    </td>
                    <td>
                      {{ item.created_at ? formatDate(item.created_at) : '-' }}
                    </td>
                    <!-- <td>
                      {{ item.type }}
                    </td> -->
                    <td>
                      <!-- <el-button class="p-1" size="mini" type="primary">
                        <a class="text-white" :href="item.link" target="_blank">Join Meeting</a>
                      </el-button> -->
                      <el-button v-if="getLink(item)" @click="join(item)" class="p-1" size="mini" type="primary">Join Meeting</el-button>
                      <el-button v-if="getLink(item)" @click="copy(item.link)" class="p-1" size="mini" type="info">Share Link</el-button>
                      <el-button v-if="item.status === 'upcoming' || !item.status" @click="cancel_meeting(item)" class="p-1" size="mini" type="danger">Cancel</el-button>
                      <el-button v-if="['ongoing', 'completed'].includes(item.status)" @click="getParticipants(item)" class="p-1" size="mini" type="warning">Participant</el-button>
                    </td>
                    <!-- <td>
                      {{ item.description ? item.description : '-' }}
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <el-empty v-if="totalRow == 0" description="No data"></el-empty>
            </div>
            <b-pagination v-if="totalRow > page_limit" v-model="currentPage" :total-rows="totalRow" :per-page="page_limit"/>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Participant" :visible.sync="modal.participant" width="50%" style="height: 600px">
      <el-table :data="participants">
        <el-table-column property="username" label="Username" width="150"></el-table-column>
        <el-table-column property="role_str" label="Role" width="150"></el-table-column>
        <el-table-column property="agent_name" label="Agent" width="150"></el-table-column>
        <el-table-column property="joined_at_str" label="Joined at" width="200"></el-table-column>
        <el-table-column property="leave_at_str" label="Leave at" width="200"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  isEmpty, upperFirst, isMatch,
} from 'lodash';
import moment from 'moment';
import humanizeDuration from 'humanize-duration';
import reportApi from '../../../api/reports';
import videoCallApi from '../../../api/videoCall';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  beforeCreate() {
    this.moment = moment;
    this.humanizeDuration = humanizeDuration;
  },
  name: 'VideoCallReports',
  metaInfo: {
    title: 'Video Call Reports',
  },
  data() {
    return {
      upperFirst,
      page_limit: 50,
      loading: {
        table: false,
      },
      modal: {
        participant: false,
      },
      callType: this.$route.query.direction_filter || '',
      status_filter: this.$route.query.status_filter || '',
      statusFilterOptions: [
        {
          value: '',
          text: 'All Status',
        },
        {
          value: 'upcoming',
          text: 'Upcoming',
        },
        {
          value: 'ongoing',
          text: 'Ongoing',
        },
        {
          value: 'completed',
          text: 'Completed',
        },
        {
          value: 'cancelled',
          text: 'Cancelled',
        },
        {
          value: 'failed', // others
          text: 'Failed',
        },
      ],
      callTypeOptions: [
        {
          value: '',
          text: 'All Type',
        },
        {
          value: 'regular',
          text: 'Regular',
        },
      ],
      reportList: [],
      participants: [],
      loaderStack: 0,
      loader: null,
      search: {
        date_range: [
          this.$route.query.start_date || new Date(),
          this.$route.query.end_date || new Date(),
        ],
      },
      page: this.$route.query.page || 1,
      totalRow: 0,
      date_picker_options: {
        // disabledDate: (time) => {
        //   const today = moment();
        //   const diff = today.diff(moment(time), 'd');
        //   if (diff > 90 || diff < 0) {
        //     return true;
        //   }
        //   if (diff === 0) {
        //     if (today.isSame(moment(time), 'd') === false) {
        //       return true;
        //     }
        //   }
        //   return false;
        // },
        shortcuts: [
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.page = val;
        this.getList();
      },
    },
  },
  async mounted() {
    this.showLoader();
    await this.getList();
    this.hideLoader();
  },
  methods: {
    getLink(meet) {
      const now = moment().format();
      const start_at = moment(meet.meeting_start_at).format();
      const end_at = moment(meet.meeting_end_at).format();
      if (['upcoming', 'ongoing'].includes(meet.status) && now >= start_at && now <= end_at) {
        return true;
      }
      return false;
    },
    copy(copyText) {
      navigator.clipboard.writeText(copyText.toLowerCase());
      this.$message({
        message: 'Linked copied',
        type: 'success',
      });
    },
    space(str) {
      return str.replace(/_/gi, ' ');
    },
    ucwords(str) {
      /* eslint-disable no-plusplus */
      const words = this.space(str).split(' ');
      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
      return words.join(' ');
    },
    dateCheck() {
      const [start_date, end_date] = this.search.date_range;
      const minTime = moment(start_date);
      const maxTime = moment(end_date);
      const diff = maxTime.diff(moment(minTime), 'd');
      if (diff > 30) {
        this.$message({
          title: this.$t('general.error.general'),
          type: 'warning',
          message: 'Reporting period that can be selected for 31 days',
          duration: 20 * 100,
          showClose: true,
        });
        this.search.date_range = [start_date, start_date];
      }
    },
    countDuration(start, end) {
      console.log(moment(start).diff(moment(end), 'second'), start, end);
      return start && end ? humanizeDuration(moment(start).diff(moment(end), 'second'), { largest: 2, round: true }) : '-';
    },
    formatDate(string, format = 'DD MMM YYYY, HH:mm:ss') {
      return string ? moment(string).format(format) : '-';
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async downloadReport() {
      this.$confirm(this.$t('report.confirm_download'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            // this.loading.table = true;
            if (isEmpty(this.search.date_range)) {
              this.search.date_range = [new Date(), new Date()];
            }
            const [start_date, end_date] = this.search.date_range;
            const response = await reportApi.downloadCallList({
              workspace_id: this.activeWorkspace._id,
              start_date: this.formatDate(start_date, 'YYYY-MM-DD'),
              end_date: this.formatDate(end_date, 'YYYY-MM-DD'),
              call_type: this.callType,
              channel_type: this.callChannel,
              status_filter: this.status_filter,
            }).catch(() => {});
            // this.loading.table = false;
            instance.confirmButtonLoading = false;
            await popupErrorMessages(response);
            this.$message({
              title: this.$t('general.success'),
              type: 'success',
              message: this.$t('general.waiting_download'),
              duration: 30 * 1000,
              showClose: true,
            });
          }
          cb();
        },
      });
    },
    async getList() {
      if (isEmpty(this.search.date_range)) {
        this.search.date_range = [new Date(), new Date()];
      }
      this.dateCheck();
      const [start_date, end_date] = this.search.date_range;
      const options = {
        page: this.page,
        start_date: this.formatDate(start_date, 'YYYY-MM-DD'),
        end_date: this.formatDate(end_date, 'YYYY-MM-DD'),
        status: this.status_filter,
      };
      if (!isMatch(this.$route.query, options)) {
        this.$router.replace({ query: options });
        return;
      }
      this.loading.table = true;
      const response = await reportApi.videoCallList({
        workspace_id: this.activeWorkspace._id,
        ...options,
      }).catch(() => {});
      this.loading.table = false;
      await popupErrorMessages(response);
      this.reportList = response.data.rows.map((item) => {
        item.status_str = this.ucwords(item.status);
        item.status_color = 'danger';
        if ((item.status === 'upcoming' || !item.status) && moment(item.meeting_end_at).format() < moment().format()) {
          item.status_str = 'Expired';
        } else if (['completed'].includes(item.status)) {
          item.status_color = 'success';
        } else if (['upcoming', 'ongoing'].includes(item.status)) {
          item.status_color = 'primary';
        }
        return item;
      });
      this.totalRow = response.data.total;
    },
    cancel_meeting(meeting) {
      this.$confirm(this.$t('video_call.cancel.confirm'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const response = await videoCallApi.cancel_meeting({
              workspace_id: this.activeWorkspace._id,
              id: meeting.id,
            }).catch(() => { instance.confirmButtonLoading = false; });
            instance.confirmButtonLoading = false;
            await popupErrorMessages(response);
            this.$message({
              title: this.$t('general.success'),
              type: 'success',
              message: this.$t('general.cancel.success'),
              duration: 30 * 1000,
              showClose: true,
            });
          }
          cb();
        },
      });
    },
    join(meeting) {
      const routeData = this.$router.resolve({ name: 'Meeting Room', params: { meeting_id: meeting.id } });
      window.open(routeData.href, '_blank');
      // window.open(`http://localhost:8823/meeting/${meeting.id}`, '_blank');
    },
    getParticipants(meeting) {
      videoCallApi.participants({
        workspace_id: this.activeWorkspace._id,
        id: meeting.id,
      }).then((res) => {
        this.participants = res.data.rows.map((v) => {
          v.role_str = this.ucwords(v.role);
          v.joined_at_str = this.formatDate(v.joined_at);
          v.leave_at_str = this.formatDate(v.leave_at);
          v.agent_name = '';
          if (v.user) {
            v.agent_name = v.user.name;
          }
          return v;
        });
        this.modal.participant = true;
      }).catch(() => {});
    },
  },
};
</script>
